export default {
  name: 'todo-anio',
  label: 'todo el año',
  formula: [
    {
      name: 'aceite esencial de naranja',
      quantity: 7.5,
      unit: 'ml',
      ref: 'naranja'
    },
    {
      name: 'aceite esencial de bergamota',
      quantity: 1.25,
      unit: 'ml',
      ref: 'bergamota'
    },
    {
      name: 'aceite esencial de mandarina',
      quantity: 4,
      unit: 'ml',
      ref: 'mandarina'
    },
    {
      name: 'aceite esencial de citronela',
      quantity: 3.75,
      unit: 'ml',
      ref: 'citronela'
    },
    {
      name: 'aceite esencial de limón',
      quantity: 5,
      unit: 'ml',
      ref: 'limon'
    },
    {
      name: 'aceite esencial de toronja',
      quantity: 7,
      unit: 'ml',
      ref: 'toronja'
    },
    {
      name: 'aceite esencial de romero',
      quantity: 7.5,
      unit: 'ml',
      ref: 'romero'
    },
  ],
  recipes: [
    {
      name: 'crema todo el año',
      ingredients: [
        {
          name: 'manteca de olivo',
          quantity: 20,
          unit: 'ml',
        },
        {
          name: 'manteca de salvado de arroz',
          quantity: 7.5,
          unit: 'ml',
        },
        {
          name: 'sinergia todo el año',
          quantity: 5,
          unit: 'ml',
        },
      ]
    },
    {
      name: 'aceite todo el año',
      notes: [
        'aceite de aguacate para piel normal, antiestrés y deportistas.'
      ],
      ingredients: [
        {
          name: 'aceite de almendras dulces',
          quantity: 60,
          unit: 'ml',
          ref: 'almendras-dulces'
        },
        {
          name: 'aceite de olivo',
          quantity: 40,
          unit: 'ml',
          ref: 'olivo'
        },
        {
          name: 'sinergia todo el año',
          quantity: 15,
          unit: 'ml',
        },
      ]
    },
    {
      name: 'loción todo el año',
      ingredients: [
        {
          name: 'agua de azahar',
          quantity: 20,
          unit: 'ml',
        },
        {
          name: 'agua de rosas',
          quantity: 40,
          unit: 'ml',
        },
        {
          name: 'mezcal',
          quantity: 40,
          unit: 'ml',
        },
        {
          name: 'sinergia todo el año',
          quantity: 7.5,
          unit: 'ml',
        },
      ]
    },
  ]
}
